<!--[title]="getTooltip()"-->

@if (!isError) {

  <img [src]="url"
       [height]="height"
       (error)="onImageError()"
       (click)="displayOriginalImage()"
       class="cursor rounded">
  @if (openable) {
    <p-dialog
      [header]="title"
      [dismissableMask]="false"
      (onHide)="closeDialog()"
      [contentStyle]="{'overflow':'visible','max-height':'600px'}"
      [(visible)]="displayOriginalImg"
      [responsive]="true" showEffect="fade"
      [modal]="true">
      <img [src]="urlOriginal"
           height="256"
           (error)="onImageError()"
           class="rounded">
    </p-dialog>
  }
}

@if (isError && !_displayNoImage) {
  <img [src]="noImageUrl"
       [height]="height"
       class="rounded">
}


